<mat-dialog-content
  style="border: 3px solid #000000; height: 1700px; width: 1400px"
>
  <div style="text-align: center">
    <h1
      *ngIf="isRuleCondition || isCustomerRuleCondition"
      style="align-content: center"
    >
      Kural Koşulları
    </h1>
    <h1 *ngIf="isRuleLicense" style="align-content: center">
      Kural Lisansları
    </h1>
    <h1 *ngIf="isCustomerRuleParameter" style="align-content: center">
      Kural Parametreleri
    </h1>
  </div>
  <mat-card>
    <span *ngIf="isRuleCondition"
      >Koşul tipi olarak aşağı 3 koşul tipi kullanılabilir. RequestField :
      HttpRequest ile gelen request nesnesinden bir bilgi okunmasını sağlar.
      ConditionExpression alanı JsonPath formatında bir veri olmalıdır.
      <br />EntityField : Kuralın çalıştırılmasını gerektiren entity nesnesidir.
      ConditionExpression alanına entity public property adı yazılabilir.
      Property.SubProperty şeklinde iç içe yazılabilir. <br />XPath : Kuralın
      çalıştırılmasını gerektiren entity nesnesinin kullandığı XmlDocument
      üzerinde xpath formatında bir veri olmalıdır.<br /><br
    /></span>
    <div *ngIf="isRuleCondition" style="display: flex; flex-direction: column">
      <div
        *ngFor="let ruleCondition of ruleDefinitionConditions; let i = index"
        [value]="ruleCondition"
      >
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Koşul Tipi" }}</mat-label>
          <mat-select [(ngModel)]="ruleCondition.conditionType">
            <mat-option
              *ngFor="let ruleCondition of ruleConditionTypeList"
              [value]="ruleCondition"
            >
              {{ ruleCondition }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Koşul İfadesi" }}</mat-label>
          <input
            class="form-element"
            matInput
            [(ngModel)]="ruleCondition.conditionExpression"
          />
        </mat-form-field>
        <button
          mat-raised-button
          style="line-height: 23px"
          color="primary"
          (click)="deleteRuleCondition(i)"
        >
          {{ "X" }}
        </button>
      </div>
      <button
        *ngIf="isRuleCondition"
        mat-raised-button
        style="line-height: 23px"
        color="primary"
        (click)="addRuleCondition()"
      >
        {{ "Ekle" }}
      </button>
    </div>
    <div *ngIf="isRuleLicense" style="display: flex; flex-direction: column">
      <div
        *ngFor="let ruleLicense of ruleDefinitionLicenses"
        [value]="ruleLicense"
      >
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Kod" }}</mat-label>
          <input
            class="form-element"
            matInput
            [readonly]="true"
            [(ngModel)]="ruleLicense.code"
          />
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Açıklama" }}</mat-label>
          <input
            class="form-element"
            matInput
            [readonly]="true"
            [(ngModel)]="ruleLicense.description"
          />
        </mat-form-field>
        <mat-checkbox
          aria-label="Aktif/Pasif"
          [(ngModel)]="ruleLicense.isActive"
          (change)="isActiveChange($event)"
        >
          Aktif/Pasif
        </mat-checkbox>
      </div>
    </div>
    <span *ngIf="isCustomerRuleCondition"
      >Koşul tipi olarak aşağı 3 koşul tipi kullanılabilir. RequestField :
      HttpRequest ile gelen request nesnesinden bir bilgi okunmasını sağlar.
      ConditionExpression alanı JsonPath formatında bir veri olmalıdır.
      <br />EntityField : Kuralın çalıştırılmasını gerektiren entity nesnesidir.
      ConditionExpression alanına entity public property adı yazılabilir.
      Property.SubProperty şeklinde iç içe yazılabilir. <br />XPath : Kuralın
      çalıştırılmasını gerektiren entity nesnesinin kullandığı XmlDocument
      üzerinde xpath formatında bir veri olmalıdır.<br /><br
    /></span>

    <div
      *ngIf="isCustomerRuleCondition"
      style="display: flex; flex-direction: column"
    >
      <div
        *ngFor="let customerRuleCondition of ruleConditions; let i = index"
        [value]="customerRuleCondition"
      >
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Koşul İfadesi" }}</mat-label>
          <mat-select
            [(ngModel)]="customerRuleCondition.ruleDefinitionConditionsId"
            (ngModelChange)="conditionChange($event, i)"
          >
            <mat-option
              *ngFor="let ruleConditionId of ruleConditionIdList"
              [value]="ruleConditionId.id"
            >
              {{ ruleConditionId.conditionExpression }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Koşul Id" }}</mat-label>

          <input
            class="form-element"
            matInput
            [readonly]="true"
            [(ngModel)]="customerRuleCondition.ruleDefinitionConditionsId"
          />
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Koşul Tipi" }}</mat-label>
          <input
            class="form-element"
            matInput
            [readonly]="true"
            [(ngModel)]="customerRuleCondition.conditionType"
          />
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Grup İndeksi" }}</mat-label>
          <input
            class="form-element"
            matInput
            type="number"
            min="0"
            [(ngModel)]="customerRuleCondition.andGroupIndex"
          />
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Karşılaştırma Tipi" }}</mat-label>
          <mat-select [(ngModel)]="customerRuleCondition.comparisonType">
            <mat-option
              *ngFor="let ruleComparison of ruleComparisonTypeList"
              [value]="ruleComparison"
            >
              {{ ruleComparison }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Değer" }}</mat-label>
          <input
            class="form-element"
            matInput
            [(ngModel)]="customerRuleCondition.value"
          />
        </mat-form-field>
        <button
          mat-raised-button
          style="line-height: 23px"
          color="primary"
          (click)="deleteCustomerRuleCondition(i)"
        >
          {{ "X" }}
        </button>
      </div>
      <button
        *ngIf="isCustomerRuleCondition"
        mat-raised-button
        style="line-height: 23px"
        color="primary"
        (click)="addCustomerRuleCondition()"
      >
        {{ "Ekle" }}
      </button>
    </div>
    <div
      *ngIf="isCustomerRuleParameter"
      style="display: flex; flex-direction: column"
    >
      <div
        *ngFor="let ruleParameter of ruleParameters; let i = index"
        [value]="ruleParameter"
      >
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Parametre Adı" }}</mat-label>
          <mat-select
            [(ngModel)]="ruleParameter.parameterName"
            (ngModelChange)="parameterChange($event, i)"
          >
            <mat-option
              *ngFor="let ruleParameter of ruleParameterIdList"
              [value]="ruleParameter.parameterName"
            >
              {{ ruleParameter.parameterName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Parametre Açıklaması" }}</mat-label>
          <input
            class="form-element"
            matInput
            [(ngModel)]="ruleParameter.parameterDescription"
            readonly="true"
          />
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Değer Listesi" }}</mat-label>
          <input
            class="form-element"
            matInput
            [(ngModel)]="ruleParameter.valueList"
            readonly="true"
          />
        </mat-form-field>
        <mat-form-field class="filter-fields" appearance="outline">
          <mat-label>{{ "Parametre Tipi" }}</mat-label>
          <mat-select [(ngModel)]="ruleParameter.parameterType">
            <mat-option
              *ngFor="let ruleParameter of ruleParameterTypeList"
              [value]="ruleParameter"
            >
              {{ ruleParameter }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          *ngIf="ruleParameter.valueList == null"
          class="filter-fields"
          appearance="outline"
        >
          <mat-label>{{ "Değer Kaynağı" }}</mat-label>
          <input
            class="form-element"
            matInput
            [(ngModel)]="ruleParameter.parameterValueSource"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="ruleParameter.valueList != null"
          class="filter-fields"
          appearance="outline"
        >
          <mat-label>{{ "Değer Kaynağı" }}</mat-label>
          <mat-select
            [(ngModel)]="ruleParameter.parameterValueSource"
            (ngModelChange)="valueSourceChange($event, i)"
          >
            <mat-option
              *ngFor="let valueSource of ruleParameter.valueList.split(';')"
              [value]="valueSource"
            >
              {{ valueSource }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox
          aria-label="Gerekli"
          [(ngModel)]="ruleParameter.required"
          (change)="requiredChange($event)"
          [disabled]="true"
        >
          Gerekli
        </mat-checkbox>
        <span>&nbsp;&nbsp;</span>
        <button
          mat-raised-button
          style="line-height: 23px"
          color="primary"
          (click)="deleteCustomerRuleParameter(i)"
        >
          {{ "X" }}
        </button>
      </div>
      <button
        *ngIf="isCustomerRuleParameter"
        mat-raised-button
        style="line-height: 23px"
        color="primary"
        (click)="addCustomerRuleParameter()"
      >
        {{ "Ekle" }}
      </button>
    </div>
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 0">
  <button
    mat-raised-button
    style="line-height: 23px"
    color="primary"
    (click)="closeDialog(true)"
  >
    {{ "Kaydet" }}
  </button>
  <button
    mat-raised-button
    style="line-height: 23px"
    color="primary"
    (click)="closeDialog(false)"
  >
    {{ "Kapat" }}
  </button>
</mat-dialog-actions>
